import { AppState } from 'store/rootReducer';

export const getRFMData = (state: AppState) => state.rfm.data;
export const getRFMLineChartData = (state: AppState) => state.rfm.lineChartData;
export const getAllTiersAverage = (state: AppState) => state.rfm.allTiersAverage;
export const getTiersAverage = (state: AppState) => state.rfm.tiersAverage;
export const getRFMRange = (state: AppState) => state.rfm.range;
export const isRFMDataLoading = (state: AppState) => state.rfm.loading;
